"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconMoving = function IconMoving(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m25.338 16.003-8.334-8.334-8.334 8.334 8.334 8.334zm-8.334-5.667 5.667 5.667-5.667 5.667-5.667-5.667 2.126-2.126 3.33 3.33 1.414-1.414-3.33-3.33zM13 42a5 5 0 0 1 4-4.9v-6.686L5.585 19H.522q.215-1.017.515-2h5.377l21.464 21.463a3 3 0 0 0 4.1.136l.145-.136 12-12a3 3 0 0 0 .87-1.925L45 24.34V22h2v2.34a5 5 0 0 1-1.28 3.345l-.183.192-12 12a5 5 0 0 1-6.882.182l-.192-.182L24 37.414l-1.828 1.829A5 5 0 1 1 13 42m9.586-6L19 32.414V37.1c.638.13 1.233.38 1.757.728zM21 42a3 3 0 1 0-6 0 3 3 0 0 0 6 0m20.389-16.056L30.135 14.69 18.88 25.944l11.255 11.255zM30.134 17.2l8.744 8.744-8.744 8.743-8.743-8.743 3.66-3.66 2.372 2.373 1.414-1.414-2.373-2.373zm1.282 9.33L28 29.943l2.12 2.121 3.417-3.415zm0 1.412.707.708-2.001 2.001-.707-.707zM16.5 42a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0",
    clipRule: "evenodd"
  })));
};

export { IconMoving, IconMoving as default };
